module.exports = __webpack_public_path__ + "static/widget_builder-ab578eeac21dbf50b6e7760c4b40fc2d.png";